import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function Navbar() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-gray-800 text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex space-x-6">
          <Link to="/productos" className="hover:text-blue-300">Productos</Link>
          <Link to="/autores" className="hover:text-blue-300">Autores</Link>
          <Link to="/noticias" className="hover:text-blue-300">Noticias</Link>
          <Link to="/usuarios" className="hover:text-blue-300">Usuarios</Link>
        </div>
        <div className="flex items-center space-x-4">
          {user && (
            <div className="flex items-center space-x-2">
              <span className="text-gray-300">
                {user.email || user.username}
              </span>
              {user.roles?.includes('admin') && (
                <span className="bg-blue-600 text-white text-xs px-2 py-1 rounded">
                  Admin
                </span>
              )}
            </div>
          )}
          <button
            onClick={handleLogout}
            className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded transition-colors"
          >
            Cerrar Sesión
          </button>
        </div>
      </div>
    </nav>
  );
}